let AbstractGeometryOperationResult = require('./abstractOperationResult');

/**
 * Класс SymmetricDifferenceResult определяет структуру результата при опрерации построения симметричной разности геометрий
 * @extends AbstractGeometryOperationResult
 */
class SymmetricDifferenceResult extends AbstractGeometryOperationResult {
  /**
   * Создает экземпляр класса SymmetricDifferenceResult
   * @param params
   */
  constructor(params) {
    super(params);
    this.type = "SymmetricDifferenceResult";
  }
}

module.exports = SymmetricDifferenceResult;